/* global $:true dataLayer:true */
/**
 * Analytics Trigger
 *
 * Send google analytics on element events.
 *
 * @example
 *    <input
 *        type="button"
 *         data-commerce-analytics-trigger
					 data-commerce-analytics-trigger-on="click"
					 data-commerce-analytics-trigger-groupname="products"
					 data-commerce-analytics-trigger-event="productClick"
					 data-commerce-analytics-trigger-action="click"
					 data-commerce-analytics-trigger-name="#40 Flat fold handle bag"
					 data-commerce-analytics-trigger-id="C486S0054"
					 data-commerce-analytics-trigger-brand="Paper-Pak"
					 data-commerce-analytics-trigger-price="232.00"
					 data-commerce-analytics-trigger-category="Carry Bags">
 *
 *    <input
 *        type="button"
 *         data-commerce-analytics-trigger
					 data-commerce-analytics-trigger-on="click"
					 data-commerce-analytics-trigger-groupname="products"
					 data-commerce-analytics-trigger-event="productClick"
					 data-commerce-analytics-trigger-action="click"
					 data-commerce-analytics-trigger-name="#40 Flat fold handle bag"
					 data-commerce-analytics-trigger-id="C486S0054"
					 data-commerce-analytics-trigger-brand="Paper-Pak"
					 data-commerce-analytics-trigger-price="232.00"
					 data-commerce-analytics-trigger-category="Carry Bags"
					 data-commerce-analytics-trigger-dynamic="quantity:#quantity:1">

		Dynamic Format
		1. Field Name
		2. Field selector
		3. Default value if selector value is empty (optional)
* @example
		data-commerce-analytics-trigger-dynamic="quantity:#quantity:1"
 */

import debug from "debug";

import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = 'body';
const MODULE_NAME = 'app.core/modules/commerce-analytics-trigger';
const log = debug(MODULE_NAME);
const ZERO = 0;
const PROMO_CLICK_EVENT_ELEMENT_SElECTOR = '[data-commerce-analytics-promo-banner]';
const TRIGGER_ELEMENT_SELECTOR = '[data-commerce-analytics-trigger]';
const NAME_ATTR = 'data-commerce-analytics-trigger-name';
const ID_ATTR = 'data-commerce-analytics-trigger-id';

class CommerceAnalyticsImpressionsPlugin {

	constructor (element) {
			this.element = element;
			this.$element = $(element);
			this.$promos = $(PROMO_CLICK_EVENT_ELEMENT_SElECTOR);
			log('CommerceAnalyticsImpressionsPlugin', element);

			this.watch();
			log('ready', this.$element);
	}

	watch () {
			this.sendPromotionImpressions();
			log('watching', this.$element);
	}

	sendPromotionImpressions() {
		var slot = 1;
		var promos = Array();
		var i =1;
		this.$promos.each(function() {
			var trigger = $(this).find(TRIGGER_ELEMENT_SELECTOR);
			if ($(trigger).length > 0) {
				var name = $(trigger).attr(NAME_ATTR);
				var id = $(trigger).attr(ID_ATTR);
				if (name.length > 0) {
					promos.push({
							'id' : id,
							'name' : name,
							'creative': '',
							'position' : 'slot' + i
					});
					i++;
				}
			}
		});
		if (promos.length > 0) {
			var dataSet = {
					'ecommerce' : {
						'promoView' : {
							'promotions' : promos
						}
					}
			};
			if (typeof(dataLayer) !=='undefined') {
	          dataLayer.push(dataSet);
	      }
			}
		}
	}

CommerceAnalyticsImpressionsPlugin.DEFAULTS = {
};

plugin('commerceAnalyticsImpressions', CommerceAnalyticsImpressionsPlugin);

export function exec () {
		$(document).ready(() => {
				log('binding');
				$(ELEMENT_SELECTOR).commerceAnalyticsImpressions();
				log('bound');
		});
}



// WEBPACK FOOTER //
// ./client/src/core/modules/commerce-analytics-impressions/index.js